// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2wF8T","label":"Category_label__3dRpy","content":"Category_content__2MdIk","header":"Category_header__3lMcN","location":"Category_location__3MdLs"};